import React, { useState } from 'react'
import { Form, Input, Button, Card, Typography, Alert } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate, Link } from 'react-router-dom'
import axios from 'axios'
import { showSuccessAlert, showErrorAlert } from '../utils/customAlert'

const { Title } = Typography

export default function RegisterPage() {
  const [alert, setAlert] = useState(null)
  const navigate = useNavigate()

  const onFinish = async (values) => {
    try {
      // 自动trim用户名和密码
      const trimmedValues = {
        username: values.username?.trim(),
        password: values.password?.trim()
      };
      const response = await axios.post('https://server.site-resources.xyz/auth/register', trimmedValues)
      setAlert({
        type: 'success',
        message: response.data.message
      })
      showSuccessAlert('注册成功！请等待管理员审核后登录。', '注册成功')
      setTimeout(() => {
        navigate('/login')
      }, 2000)
    } catch (error) {
      if (error.response && error.response.status === 409) {
        showErrorAlert('用户名已存在', '注册失败');
      } else if (error.response && error.response.status === 400) {
        showErrorAlert('用户名或密码格式错误', '注册失败');
      } else {
        showErrorAlert('注册失败，请重试', '错误');
      }
      setAlert({
        type: 'error',
        message: '注册失败'
      });
    }
  }

  return (
    <div style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center', background: '#f0f2f5' }}>
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ margin: 0 }}>用户注册</Title>
          <p style={{ color: '#666', margin: '8px 0 0 0' }}>创建您的账户</p>
        </div>
        
        {alert && (
          <Alert
            message={alert.message}
            type={alert.type}
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        
        <Form
          name="register"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名!' },
              { min: 3, message: '用户名至少3个字符!' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="用户名" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码!' },
              { min: 6, message: '密码至少6个字符!' }
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="密码" 
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: '请确认密码!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致!'));
                },
              }),
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="确认密码" 
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              注册
            </Button>
          </Form.Item>
          
          <div style={{ textAlign: 'center' }}>
            <span style={{ color: '#666' }}>已有账户？</span>
            <Link to="/login" style={{ marginLeft: 8 }}>立即登录</Link>
          </div>
          
          <div style={{ marginTop: 16, padding: 12, background: '#f6f8fa', borderRadius: 6 }}>
            <p style={{ margin: 0, fontSize: 12, color: '#666' }}>
              <strong>注意：</strong>新注册用户需要管理员审核后才能登录系统。
            </p>
          </div>
        </Form>
      </Card>
    </div>
  )
} 